import { AppDispatch } from "@store/store";
import { loginWithMagicLink } from "../../visitWidgetApi";
import { authTokenSuccessAction } from "./authTokenSuccessAction";
import { logInfo } from "@lib/logger";

const signInWithMagicLinkAction =
  (magicLinkToken: string) => async (dispatch: AppDispatch) => {
    try {
      const response = await loginWithMagicLink(magicLinkToken);
      await dispatch(authTokenSuccessAction({ authToken: response.authToken }));
    } catch (error) {
      logInfo(error);
      throw error;
    }
  };

export { signInWithMagicLinkAction };
